import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Сервисные работы", -1)
const _hoisted_3 = { class: "base-form filter" }
const _hoisted_4 = { class: "base-form filter" }
const _hoisted_5 = { class: "base-form filter" }
const _hoisted_6 = { class: "base-form filter" }
const _hoisted_7 = { class: "base-form filter" }
const _hoisted_8 = { class: "base-form filter" }
const _hoisted_9 = { style: {"display":"table","height":"100%","width":"100%"} }
const _hoisted_10 = { style: {"display":"table-cell","vertical-align":"baseline","width":"20px"} }
const _hoisted_11 = { style: {"display":"table-cell","vertical-align":"middle","padding-left":".56rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_component_groups_tree_filter_component = _resolveComponent("component-groups-tree-filter-component")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onAddJobClick,
                icon: _ctx.circleIcon,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новая сервисная работа ")
                ]),
                _: 1
              }, 8, ["onClick", "icon"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableSearchQuery,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableSearchQuery) = $event)),
                placeholder: "Поиск по компонентам, категориям, операциям и группам работ",
                clearable: "",
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 24 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_component_groups_tree_filter_component, {
                "onUpdate:modelValue": [
                  _ctx.onTableComponentGroupsFilterUpdate,
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableComponentGroupsFilter) = $event))
                ],
                modelValue: _ctx.tableComponentGroupsFilter
              }, null, 8, ["onUpdate:modelValue", "modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tableCategoriesFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tableCategoriesFilter) = $event)),
                onChange: _ctx.fetchJobsAsync,
                multiple: "",
                clearable: "",
                filterable: "",
                placeholder: "Фильтр по категориям"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceJobCategories, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tableOperationsFilter,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tableOperationsFilter) = $event)),
                onChange: _ctx.fetchJobsAsync,
                multiple: "",
                clearable: "",
                filterable: "",
                placeholder: "Фильтр по операциям"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceJobOperations, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tableGroupsFilter,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tableGroupsFilter) = $event)),
                onChange: _ctx.fetchJobsAsync,
                multiple: "",
                clearable: "",
                filterable: "",
                placeholder: "Фильтр по группе работ"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceJobGroups, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 24 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_icon, {
                    size: 18,
                    style: {"margin":".32rem 0 0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CircleClose, {
                        color: _ctx.isFiltersEnabled() ? 'var(--el-color-primary)' : 'var(--el-color-info-light-5)'
                      }, null, 8, ["color"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_link, {
                    disabled: !_ctx.isFiltersEnabled(),
                    type: _ctx.isFiltersEnabled() ? 'primary' : 'info',
                    underline: false,
                    onClick: _ctx.onClearFiltersButtonClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Очистить фильтр ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "type", "onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                "row-key": "id",
                sortable: "custom",
                data: _ctx.tableData,
                "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
                onSortChange: _ctx.onTableSortingChange,
                onRowClick: _ctx.onTableRowClick
              }, {
                empty: _withCtx(() => [
                  _createTextVNode(" Список сервисных работ пуст, попробуйте изменить фильтр ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { type: "selection" }),
                  _createVNode(_component_el_table_column, {
                    label: "Компонент",
                    prop: "componentname",
                    sortable: "",
                    "column-key": "componentname"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.component.name) + " ", 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_text, { type: "info" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.component.componentGroup?.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Операция",
                    prop: "operation.name"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Категория",
                    prop: "category.name",
                    sortable: "",
                    "column-key": "categoryname"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Стоимость НЧ (₽)",
                    prop: "category.costPerHour",
                    sortable: "",
                    "column-key": "categorycostperhour"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Трудозатраты (час)",
                    prop: "estimationHrs"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Группа работ",
                    prop: "groupname",
                    sortable: "",
                    "column-key": "groupname"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.group?.name ?? ''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    width: "120",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "danger",
                        onClick: (e) => _ctx.onDeleteJobClick(e, scope.row.id)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Удалить ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "default-sort", "onSortChange", "onRowClick"])), [
                [_directive_loading, _ctx.tableLoading]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}